import React from "react";
import "./titano.css";
import Slide from "react-reveal/Slide";

function Titano() {
  return (
    <div className="mainTitano">
      <Slide right>
        <div className="subtitano">
          <h4 className="titano11">
            Titano rewards holders with
            <br />
            automatic compounding <br />
            interest, increasing their TITANO <br />
            holdings over time.
          </h4>
        </div>
      </Slide>
    </div>
  );
}

export default Titano;
